import random from 'toxilibs/random.js'
import Level from '../core/level.js'
import mathText from '../math_text.js'

const level = new Level({
    name: 'simple_length',
    dependencies: []
})



function common (q, b) {

    let a = {
        x: 0,
        y: 0,
        color: '#00F'
    }

    a.name = 'A'
    b.name = 'B'
    b.color = '#09C'

    let geoScreen = q.addGeoScreen({
        noAxes: true
    })

    geoScreen.addPolygon({points: [a, b], displayPoints: true})

    q.addText(mathText.pointsDistance(a, b) + ' ?')
    q.answer = Math.abs(a.x - b.x + a.y - b.y)

}


level.addQuestion({
    generator: function (q) {
        q.smartChoose([
            {1:   3},
            {1:   5},
            {1:   2},
            {all: q.intBetween(1, 8)}
        ], function (value) {
            common(q, {
                x: value,
                y: 0
            })
        })

        q.addBadChoices(
            -q.answer,
            'i_pawn',
            'digit'
        )


    }
})


level.addQuestion({
    generator: function (q) {

        common(q, {
            x: 0,
            y: random.fairChoiceInt(1, 6)
        })

    }
})


level.addQuestion({
    generator: function (q) {
        q.smartChoose([
            {1:   -3},
            {1:   -5},
            {all: q.intBetween(-7, -1)}
        ], function (value) {
            common(q, {
                x: value,
                y: 0
            })
        })


        q.addBadChoices(
            -q.answer,
            () => random.intBetween(-9, 9)
        )

    }
})


export default level

